import { memo } from 'react';
import { isEnum, isMultienum, isTextarea, isSingleLineText } from 'customer-data-objects/property/PropertyIdentifier';
import { getDisplayedValue } from 'customer-data-property-utils/PropertyValueDisplay';
import { getTransferrableProps } from '../utils/getTransferrableProps';
import emptyFunction from 'react-utils/emptyFunction';
import useComponentMountMetric from '../metrics/useComponentMountMetric';
import { useProperty } from '../v2/hooks/useProperty';
import { usePropertyValue } from '../v2/hooks/usePropertyValue';
import TextInputAdapter from '../adapters/TextInput';
import ExpandingTextAreaAdapter from '../adapters/ExpandingTextArea';
import { ExpandableText } from 'foundations-components/transitional/components/ExpandableText';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyInputReadOnly = props => {
  const {
    defaultValue,
    dateFormat,
    dateTimeFormat,
    relativeDate,
    relativeDateTime,
    objectTypeId
  } = props;
  const property = useProperty();
  const value = usePropertyValue();
  useComponentMountMetric('PropertyInputReadOnly');
  let displayValue = getDisplayedValue(property, value, undefined, {
    dateFormat,
    dateTimeFormat,
    relativeDate,
    relativeDateTime,
    showDateDisplayHintLabel: true
  }, objectTypeId);
  if (displayValue === '') {
    displayValue = defaultValue;
  }
  if (isTextarea(property) || isSingleLineText(property) || isEnum(property) && isMultienum(property)) {
    return /*#__PURE__*/_jsx(ExpandableText, {
      hideButtonCaret: true,
      children: /*#__PURE__*/_jsx(ExpandingTextAreaAdapter, Object.assign({}, getTransferrableProps(props), {
        value: displayValue,
        onChange: emptyFunction,
        readOnly: true,
        shrink: true
      }))
    });
  }
  return /*#__PURE__*/_jsx(TextInputAdapter, Object.assign({}, getTransferrableProps(props), {
    value: displayValue,
    onChange: emptyFunction,
    readOnly: true
  }));
};
export default /*#__PURE__*/memo(PropertyInputReadOnly);